import { z } from "zod";
export const DTOLiveblocksAuthResponse = z.object({
    token: z.string(),
});
